(function () {
  var STORAGE_KEY = 'phsiq_contact_saved_info';

  function initContactPage(section) {
    if (section.dataset.contactInit) return;
    section.dataset.contactInit = 'true';

    var nameField = section.querySelector('input[name="contact[name]"]');
    var emailField = section.querySelector('input[name="contact[email]"]');
    var saveCheckbox = section.querySelector('.contact-page__checkbox input[type="checkbox"]');
    var form = section.querySelector('.contact-page__form');

    if (!nameField || !emailField || !form) return;

    // Prefill from a previous visit, if the visitor opted in before.
    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (saved) {
        nameField.value = saved.name || '';
        emailField.value = saved.email || '';
        if (saveCheckbox) saveCheckbox.checked = true;
      }
    } catch (e) {
      /* localStorage unavailable or corrupted value: ignore silently. */
    }

    form.addEventListener('submit', function () {
      if (!saveCheckbox) return;
      try {
        if (saveCheckbox.checked) {
          localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({ name: nameField.value, email: emailField.value })
          );
        } else {
          localStorage.removeItem(STORAGE_KEY);
        }
      } catch (e) {
        /* Ignore storage failures (private browsing, quota, etc.). */
      }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.contact-page').forEach(initContactPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
